/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'
import { formatDateTime } from '../../../../../utils/Helpers'

const GET_LAST_UPDATED_OFFERS = gql`
  query LastUpdatedOffer($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0,
      filters: $filters
      aggs: {
        pharmacyTotalOffer: {
          max: {
            field: "pharmacyLastUpdated"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const LastUpdatedOffer = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_LAST_UPDATED_OFFERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const date = formatDateTime(data.pharmaciesAggs.aggregations.pharmacyTotalOffer.value_as_string)

  return (
    <CardWidget title="Último envio de oferta" number={date!} color={Colors.blue} />
  )
}

export default LastUpdatedOffer
